import React from "react";

const ContactMessages = () => {
  return <div>ContactMessages</div>;
};

export default ContactMessages;
